module.exports = __webpack_public_path__ + "img/88.ae58ba45.jpg";